export class ClientPreview {
    public id: string | any;
    public active: boolean | any;
    public name: string | any;
    public appInstanceName: string | any;
    public createDate: Date | any;
}

export class Client {
    public id: number | undefined;
    public city!: string;
    public country!: string;
    public address!: string;
    public createDate: Date | undefined;
    public email!: string;
    public name!: string;
    public phone!: string;
    public postCode!: string;
    public vatNumber!: string;
}

export class PaymentInfo {
    public billingPeriod!: BillingPeriod;
    public status!: number;
    public debt!: number;
}

export class PaymentHisotryItem {
    public id!: string;
    public invoiceNumber!: string;
    public date: Date | any;
    public amount: number | any;
    public title!: string;
    public status: number | any;
    public transaction!: string;
    public invoiceId!: string;
    public reportId!: string;
}

export class User {
    public id!: string;
    public login!: string;
    public internalId!: number;
    public active!: string;
}

export interface BillingReport {
    billingPeriod: BillingPeriod;
    pricelist: string
    ordersCount: number;
    productsCount: number;
    auctionsCount: number;
    shipmentsCount: number;
    dailyReports: BillingDailyReport[] | [];
}

export interface BillingPeriod {
    from: Date;
    to: Date;
}

export interface BillingDailyReport {
    date: Date;
    ordersCount: number;
    productsCount: number;
    auctionsCount: number;
    shipmentsCount: number;
}

export interface CardChargeLog {
    ts: Date;
    success: boolean;
    details: string;
}

export interface PaymentAmountDetail {
    title: string;
    netAmount: number;
    grossAmount: number;
    notes: string;
}
export class PaymentCard {
    public id!: string;
    public mask!: string;
    public expireAt!: string;
    public type!: string;
    public primary!: boolean;
    public source!: string;
    public paymentSystem!: number;
}
